import { Button } from "reactstrap";

export default function CommonButton ({
    color,type,buttonAction,buttonText,className,outline,disabled, icon = null, btnTxtClsName = ""
}) {
    return(
        <Button color={color} outline={outline} className={className} type={type} onClick={buttonAction}  disabled={disabled} >
            {icon}
            <span className={btnTxtClsName}>{buttonText}</span>
        </Button>
    )
}